import React from 'react'
import { getYear, getMonth, startOfQuarter } from 'date-fns'
import css from './quarterPicker.module.css'
import cn from '../../../../../utils/cn.ts'

const quarters = ['Q1', 'Q2', 'Q3', 'Q4']

interface Props {
  currentMonth?: Date
  startDate: Date
  range?: boolean
  double?: boolean
  endDate?: Date
  onSelect: (date: Date | [Date, Date]) => void
}

const QuarterPicker: React.FC<Props> = ({ startDate, endDate, range, double, currentMonth, onSelect }) => {
  const currentYear = currentMonth ? getYear(currentMonth) : new Date().getFullYear()
  const getQuarter = (date: Date) => Math.floor(getMonth(date) / 3)
  const isStartQuarter = (quarterIndex: number, year: number) => {
    return range && startDate && getYear(startDate) === year && getQuarter(startDate) === quarterIndex
  }
  const isEndQuarter = (quarterIndex: number, year: number) => {
    return range && endDate && getYear(endDate) === year && getQuarter(endDate) === quarterIndex
  }
  const isRangeQuarter = (quarterIndex: number, year: number) => {
    return (
      range &&
      startDate &&
      endDate &&
      (year > getYear(startDate) || (year === getYear(startDate) && quarterIndex > getQuarter(startDate))) &&
      (year < getYear(endDate) || (year === getYear(endDate) && quarterIndex < getQuarter(endDate)))
    )
  }
  const isSelectedQuarter = (quarterIndex: number, year: number) => {
    return !range && startDate && getYear(startDate) === year && getQuarter(startDate) === quarterIndex
  }
  const handleQuarterClick = (quarterIndex: number, year: number) => {
    const selectedDate = startOfQuarter(new Date(year, quarterIndex * 3))
    onSelect(selectedDate)
  }

  const renderQuarterPicker = (year: number) => (
    <div className={css.quarterPicker}>
      {quarters.map((quarter, index) => (
        <div
          key={quarter + index}
          className={cn({
            [css.quarterOption]: true,
            [css.selected]: isSelectedQuarter(index, year),
            [css.startQuarter]: isStartQuarter(index, year),
            [css.endQuarter]: isEndQuarter(index, year),
            [css.rangeQuarter]: isRangeQuarter(index, year),
          })}
          onClick={() => handleQuarterClick(index, year)}
        >
          {quarter}
        </div>
      ))}
    </div>
  )

  return (
    <div className={css.wrapperContainer}>
      {renderQuarterPicker(currentYear)}
      {double && renderQuarterPicker(currentYear + 1)}
    </div>
  )
}

export default QuarterPicker
